module.exports = require("./fr-MR");